import { toRefs, watch } from 'vue';
import { useProductsStore } from '@dh-io-emh/shared/src/stores/products/products.composable';
import { useTracking } from '@dh-io-emh/shared/src/composables/tracking.composable';

export const useFilterTracking = () => {
  const productsStore = useProductsStore();
  const { selectedTab } = toRefs(productsStore.selectors);
  const { results: searchResults } = toRefs(productsStore.state);

  const { trackLinkClick, getProductsDataTrackingObject } = useTracking();

  const trackResetAllFilters = () => {
    const stopSearchResultsWatcher = watch(
      () => searchResults.value,
      () => {
        trackLinkClick({
          eventDetail: {
            category: 'filter',
            action: `remove.${selectedTab.value}`,
            label: 'reset',
            filter: [],
            products: getProductsDataTrackingObject(searchResults.value),
          },
        });

        stopSearchResultsWatcher();
      },
    );
  };

  return {
    trackResetAllFilters,
  };
};
